// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kz253","circleContainer":"styles_circleContainer__1w1Kw","circle":"styles_circle__TS6P9","iconWrapper":"styles_iconWrapper__hnpW3"};